import { API_CCM_PATIENT_CALL } from 'services/dataService/resources';

import useApi from './use-api';

interface ISendInfoData {
  callId: string;
  patientGuid: string;
}

export const useSendCcmPatientCall = () => {
  const { loading, createData } = useApi();

  const sendInfo = async (data: ISendInfoData) => {
    await createData(API_CCM_PATIENT_CALL, data);
  };

  return {
    loading,
    sendInfo,
  };
};
